/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { IconButton, styled, Typography } from "@mui/material";

export const StyledSubTitle = styled(Typography)({
  fontSize: '16px',
  lineHeight: '20px',
  color: '#515152'
})

export const StyledIconButton = styled(IconButton)({
  border: '1px solid #e1dcdc',
  borderRadius: '8px',
  padding: '7px',
  marginLeft: '8px'
})
